//import { authHeader } from '../../_helpers/auth-header';
//import { appConfig }        from '../../config/appConfig';
//import auth                   from '../auth';

import { appConfig, headerConfig, refineHeader } from '../../config';

export const emailManagerService = {
    emailOverview,
    getCoutnryCity,
    createEmailManager,
    getEmailManagerDetail,
    editEmailManager,
    deleteEmail,
    sendTestMail,
    getDealList,
    emailTemplate,
    exportSubscriber,
    importSubscriberList,
    getSubscriberFile,
    disableFile,
    getTotalSubscriber,
    addNotification,
    notification,
    getNotification,
    emailStatus,
    exportUsers,
    addMarket,
    marketList,
    getMarketDetail,
    deleteDetail
};

function createEmailManager(postData) {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}email-manager/create`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function editEmailManager(postData) {
    refineHeader();
    const requestOptions = {
        method: 'PUT',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}email-manager/edit`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
 
function emailOverview(postData) {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}email-manager/list`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function getCoutnryCity() {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
    };
 
    return fetch(`${appConfig.api.url}city/country_city`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function getEmailManagerDetail(id){
    refineHeader();
    const requestOptions = {
        method: 'GET',
        headers: headerConfig.headerDatas,
        mode: 'cors',
    };
 
    return fetch(`${appConfig.api.url}email-manager/detail/${id}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function deleteEmail(id){
    refineHeader();
    const requestOptions = {
        method: 'DELETE',
        headers: headerConfig.headerDatas,
        mode: 'cors',
    };
 
    return fetch(`${appConfig.api.url}email-manager/delete/${id}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function sendTestMail(postData) {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}email-manager/test-email`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function emailTemplate(postData) {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}email-template/email-manager-template`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function getDealList(postData) {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}email-manager/deal-list`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function exportSubscriber(postData) {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}subscribers/export-subscribers`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function exportUsers(postData) {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}user/export-users-list`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function importSubscriberList(fromData, url) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerImage,
    mode: "cors",
    body: fromData
  };

  return fetch(`${appConfig.api.url}${url}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getSubscriberFile(postData){
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}subscribers/import-subscribers-files`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function disableFile(fileID){
    refineHeader();
    const requestOptions = {
        method: 'GET',
        headers: headerConfig.headerDatas,
        mode: 'cors',
    };
 
    return fetch(`${appConfig.api.url}subscribers/disable/${fileID}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function getTotalSubscriber(postData) {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}email-manager/total-subscribers`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function addNotification(fromData, url) {
  refineHeader();
  const requestOptions = {
    method: "POST",
    headers: headerConfig.headerImage,
    mode: "cors",
    body: fromData
  };

  return fetch(`${appConfig.api.url}${url}`, requestOptions)
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function notification(postData) {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}notifications/list`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getNotification(notificationId) {
    refineHeader();
    const requestOptions = {
        method: 'GET',
        headers: headerConfig.headerDatas,
        mode: 'cors',
    };
 
    return fetch(`${appConfig.api.url}notifications/detail/${notificationId}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function emailStatus(postData) {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}email-manager/view-stats`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function addMarket(postData, url) {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerImage,
        mode: 'cors',
        body: postData
    };
 
    return fetch(`${appConfig.api.url}${url}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function marketList(postData) {
    refineHeader();
    const requestOptions = {
        method: 'POST',
        headers: headerConfig.headerDatas,
        mode: 'cors',
        body: JSON.stringify( postData )
    };
 
    return fetch(`${appConfig.api.url}campaign-market/list`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getMarketDetail(marketId) {
    refineHeader();
    const requestOptions = {
        method: 'GET',
        headers: headerConfig.headerDatas,
        mode: 'cors',
    };
 
    return fetch(`${appConfig.api.url}campaign-market/detail/${marketId}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function deleteDetail(url){
    refineHeader();
    const requestOptions = {
        method: 'DELETE',
        headers: headerConfig.headerDatas,
        mode: 'cors',
    };
 
    return fetch(`${appConfig.api.url}${url}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
            }
 
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
 
        return data;
    });
}










// WEBPACK FOOTER //
// ./src/app/services/API/emailManagerService.js